import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import CollectionDatasetCards from '../components/CollectionDatasetCards';
import CollectionDatasetsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionDatasetsPanelContainer';
import CollectionDatasetsFilters from './CollectionDatasetsFilters';

const CollectionDatasetsPanelNarrow = ({
  canManage,
  canRead,
  category,
  code,
  currentPage,
  datasets,
  fetchData,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  showAddDataset,
  total,
}) => {
  paging.useFetchByCode(fetchData, category, code, readStatus, reFetchConfig(datasets, { pageSize, total }));
  return (
    <CollectionDatasetsPanelContainer
      readErrors={readErrors}
      canRead={canRead}
      className="aridhia-collection-datasets-panel-narrow"
    >
      <div className="sticky-panel-header">
        <CollectionDatasetsFilters category={category} code={code} className="aridhia-list-filter" fluid />
      </div>
      <CollectionDatasetCards
        canCreate={canManage}
        category={category}
        code={code}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={datasets}
        itemsPreRow={1}
        readErrors={readErrors}
        readStatus={readStatus}
        showAddDataset={showAddDataset}
      />
    </CollectionDatasetsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetsPanelNarrow);
